<div id="layoutSidenav">
    <div id="layoutSidenav_content">

        <div class="container-fluid px-5 pt-5 mt-4">
            <!-- Total Leads Section -->
            <!-- Coupon Banner -->


            <h2 class="mb-4">Service Partners</h2>

            <div style="float: right;">
                <button type="button" class="btn btn-primary" (click)="addServicePartner()">Add Service Partner</button>
            </div>

            <!-- Data Table -->
            <div class="table-responsive thtdfix">
                <table class="table table-hover">
                    <thead class="table-primary">
                        <tr>

                            <th>S.No</th>
                            <th>Service Type</th>
                            <th>Organisation Name</th>
                            <th>Contact Person</th>
                            <th>Mobile Number</th>
                            <th>Email Id</th>
                            <th>City</th>
                            <th>Security Deposit</th>
                            <th>Date</th>
                            <th>Doc</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tr *ngFor="let partners of servicePartners; let i=index;">
                        <td>{{ i+1 }}</td>
                        <td>{{ partners.serviceType }}</td>
                        <td>{{ partners.organisationName }}</td>
                        <td>{{ partners.contactPerson}}</td>
                        <td>{{ partners.mobileNumber}}</td>
                        <td>{{ partners.emailId}}</td>
                        <td>{{ partners.city}}</td>
                        <td>{{partners.securityDeposit}}</td>
                        <td>{{ partners.date }}</td>
                        <td>
                            <i class="fa-solid fa-file-pdf text-danger" style="cursor: pointer; font-size: 24px;"></i>
                          </td>

                        <!-- Add any action buttons here -->
                        <td class="text-center">
                            <button class="btn btn-sm btn-outline-primary me-2" (click)="editService(partners,i)">
                              <i class="fa-solid fa-pen-to-square" ></i>
                            </button>
                            <button class="btn btn-sm btn-outline-danger" (click)="deleteService(i)">
                              <i class="fa-solid fa-trash"></i>
                            </button>
                          </td>

                    </tr>
                  
                </table>
            </div>
        </div>

    </div>
</div>